<template>
  <div class="prize-saver">
    <b-row>
      <b-col order="1" order-sm="1" order-md="0" class="text-center text-md-left">
        <h1>Prize Saver Draw Results</h1>
        <b-select
            size="lg"
            class="draw-selection mb-4 w-auto mr-2"
            v-model="selected.year"
            :options="drawYears"
            @input="(v) => {
              selected.year = v;
              selected.month = drawMonths[0].value
            }"
          />
        <b-select
            size="lg"
            class="draw-selection mb-4 w-auto"
            v-model="selected.month"
            :options="drawMonths"
            @input="(v) => selected.month = v"
          />
        <div v-if="description" v-html="description" class="mb-0"></div>
      </b-col>
      <b-col order="0" order-sm="0" order-md="1" cols="10" offset="1" md="6" lg="4">
        <b-img
            fluid
            rounded
            src="/tiles/prizesaver.png"
            alt="Prize Saver"
            class="mb-3 mb-md-0"
          />
      </b-col>
    </b-row>
    <b-row  v-if="selectedDraw !== null" class="mt-3">
      <b-col
          cols="12"
          :lg="index === 0 ? 12 : 6"
          class="text-center prize mb-3"
          v-for="(prize, index) in details"
          :key="`prize-${index}`">
        <div
            class="h-100 border p-3 rounded"
            :class="{
              'border-success': index === 0
            }"
        >
        <h3 class="font-weight-bold text-success">{{ formatToCurrency(prize.amount, 0) }} Prize{{ prize.winners.length > 1 ? ` x ${prize.winners.reduce((a,c) => a + c.count, 0)}` : '' }}</h3>
        <div class="winners" v-for="(winner, index) in prize.winners" :key="`winner-${index}`">
          <h5>{{ winner.name }}{{ winner.count > 1 ? ` x ${winner.count}` : '' }}</h5>
        </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {prizeSaverDraw} from "@/data/prize-saver-draw";
import {formatToCurrency} from "../../../data/utils-number";

export default {
  name: 'PrizeSaverDraw',
  methods: {formatToCurrency},
  metaInfo() {
    return {
      title: 'Prize Saver - Draws | Cash Box Credit Union',
      meta: [
        { name: 'keywords', content: "prize saver, prize, saver, cashbox, credit union, credit, union" },
        { name: 'description', content: "The credit union savings account with a chance to win £5,000 every month!" }
      ],
    };
  },
  data() {
    return {
      selected: {
        year: null,
        month: null
      }
    }
  },
  mounted() {
    this.selected.year = this.drawYears[0].value;
    this.$nextTick(() => {
      this.selected.month = this.drawMonths[0].value;
    });
  },
  computed: {
    drawYears() {
      return this.draws
          .map(x => x.year)
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => b - a)
          .map(x => ({text: x, value: x}));
    },
    drawMonths() {
      let m = this.draws
          .filter(x => x.year === this.selected.year)
          .map(x => ({text: x.text, value: x.month}));
      console.log(m);
      return m;
    },
    selectedDraw() {
      return this.draws.find(x => x.year === this.selected.year && x.month === this.selected.month)?.value;
    },
    draws() {
      return prizeSaverDraw.map(x => {
        let date = new Date(`${x.date}-01`);
        let text = date.toLocaleDateString('en-GB', {month: 'long'});
        return {
          text: text,
          value: x.date,
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          date: date
        }
      })
      .sort((a, b) => b.date - a.date);
    },
    description() {
      return prizeSaverDraw
          .find(x => x.date === this.selectedDraw)
          ?.description ?? "";
    },
    details() {
      return prizeSaverDraw
          .find(x => x.date === this.selectedDraw)
          ?.prizes
          .map(x => {
            return {
              amount: x.amount,
              // group credit unions with total number appears
              winners: x.creditUnions.reduce((acc, val) => {
                let existing = acc.find(y => y.name === val);
                if (existing) {
                  existing.count++;
                } else {
                  acc.push({name: val, count: 1});
                }
                return acc;
              }, []).sort((a, b) => a.name.localeCompare(b.name))
            }
          }) ?? [];
    }
  }
}
</script>

<style scoped>

</style>
